import React from 'react';
import { MailIcon } from 'lucide-react';
import { LinkedInMark } from './icons/LinkedInMark';
import { Logo } from './Logo';
import { linkedInUrl, navLinks, supportEmail } from '../data/site';
export function Footer() {
  return <footer className="border-t border-line" data-id="element-108" data-mp="32p5qssbzpiul">
      <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-6 px-6 py-10 sm:flex-row sm:items-center sm:justify-between lg:px-16" data-id="element-109" data-mp="36pfutzg81z6t">
        <div className="flex flex-col gap-3" data-id="element-110" data-mp="3ug3c3bc12161">
          <Logo size="sm" data-id="element-111" data-mp="3ud7ifz77pyne" />
          <a href={`mailto:${supportEmail}`} className="inline-flex items-center gap-2 text-sm font-medium text-muted transition-colors duration-150 ease-out hover:text-accent-ink" data-id="element-112" data-mp="3990ijjp5eap">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="3qcdtr3ly4ftg" />
            {supportEmail}
          </a>
          <a href={linkedInUrl} target="_blank" rel="noreferrer noopener" className="inline-flex w-fit items-center gap-2 text-sm font-medium text-muted transition-colors duration-150 ease-out hover:text-accent-ink" data-id="element-114" data-mp="29y5l8cy0g70t">
            <LinkedInMark className="h-4 w-4" data-id="element-115" data-mp="3gaz213feglk3" />
            Follow us on LinkedIn
          </a>
        </div>
        <nav aria-label="Footer" data-id="element-116" data-mp="3v7zvbbd8ooko">
          <ul className="flex flex-wrap items-center gap-x-7 gap-y-2" data-id="element-117" data-mp="3v918pmhq9n5k">
            {navLinks.map(link => <li key={link.label} data-id="element-118" data-mp="3qaq1ljithqr1">
                <a href={link.href} className="text-sm text-muted transition-colors duration-150 ease-out hover:text-heading" data-id="element-119" data-mp="82idhvaq8efw">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="text-sm text-subtle" data-id="element-120" data-mp="cu0hks81qv53">
          © {new Date().getFullYear()} Ziaxen. All rights reserved.
        </p>
      </div>
    </footer>;
}